module.exports = __webpack_public_path__ + "static/media/MobileMainBanner.89badb1d.png";